// extracted by mini-css-extract-plugin
export default {"nav":"BurgerNav_nav__qNYDQ","item":"BurgerNav_item__idBk-","link":"BurgerNav_link__VRU7U","show":"BurgerNav_show__rfZTW"};